module.exports = __webpack_public_path__ + "static/img/bg-03.7c1af0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zt/bg-03.jpg
// module id = Y3TR
// module chunks = 1